export class UserPermissionParameters {
    UserId: number;
    ModuleId: number;
    UnitId: number;
}